import { Alert, Button, Spinner } from "@heroui/react";

import { AppSettingsForm } from "@/components/app-settings/app-settings-form";
import { useGetAppSettings } from "@/hooks/api/app-settings/useGetAppSettings";
import { getApiErrorMessage } from "@/utils/api-error";

export const AppSettingsPanel = ({
  actionSlot,
}: {
  actionSlot: HTMLElement | null;
}) => {
  const settingsQuery = useGetAppSettings();

  if (settingsQuery.isPending) {
    return (
      <div className="flex justify-center py-16">
        <Spinner />
      </div>
    );
  }

  if (settingsQuery.isError) {
    return (
      <Alert className="max-w-3xl" status="danger">
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Title>
            {getApiErrorMessage(settingsQuery.error, "Failed to load settings")}
          </Alert.Title>
        </Alert.Content>
        <Button
          size="sm"
          variant="danger-soft"
          onPress={() => settingsQuery.refetch()}
        >
          Retry
        </Button>
      </Alert>
    );
  }

  return (
    <AppSettingsForm actionSlot={actionSlot} settings={settingsQuery.data} />
  );
};
